// This must run before appendConvermaxHelpers because its imported platform helpers
// read window.Convermax during module evaluation.
window.Convermax = window.Convermax || {};
